import Checkbox from 'components/Checkbox/Checkbox';
import React from 'react';
import './policyTypeRadio.scss';
import { policyTypes } from 'components/ProviderPlatformCharges/util';

type PolicyTypeRadioProps = {
  selectedPolicies: number[];
  onChange: Function;
  isFirmAdmin: boolean;
  error?: boolean;
};

const PolicyTypeRadio: React.FC<PolicyTypeRadioProps> = ({
  selectedPolicies,
  onChange,
  isFirmAdmin,
  error = false
}) => {
  return (
    <>
      <div className={`policyRadioButtonContainer ${error && 'error'}`}>
        {policyTypes.map(policyType => {
          return (
            <div style={{ width: '250px' }} key={policyType.name}>
              <Checkbox
                onClick={() => onChange(Number(policyType.value))}
                label={policyType.name}
                disabled={!isFirmAdmin}
                isChecked={
                  !selectedPolicies || selectedPolicies.length === 0
                    ? false
                    : selectedPolicies.includes(Number(policyType.value))
                }
              />
            </div>
          );
        })}
      </div>
      {error && (
        <div style={{ color: 'red' }}>
          You must select at least one policy type
        </div>
      )}
    </>
  );
};

export default PolicyTypeRadio;
